import { render, staticRenderFns } from "./PayOff.vue?vue&type=template&id=84fcfea0&scoped=true"
import script from "./PayOff.vue?vue&type=script&lang=js"
export * from "./PayOff.vue?vue&type=script&lang=js"
import style0 from "./PayOff.vue?vue&type=style&index=0&id=84fcfea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fcfea0",
  null
  
)

export default component.exports